export default {
  path: '/2019BreakTheLimit',
  name: '2019BreakTheLimit',
  component: () => import('./Home.vue'),
  redirect: '/2019BreakTheLimit/desc',
  meta: {
    title: 'Break the Limit-创·无界首届国际青年短视频大赛',
  },
  children: [
    {
      path: 'desc',
      component: () => import('./Rules.vue'),
      name: '2019BreakTheLimit/Rules',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
    {
      path: 'signUp',
      component: () => import('./SignUp.vue'),
      name: '2019BreakTheLimit/SignUp',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
    {
      path: 'firstStage',
      component: () => import('./FirstStage.vue'),
      name: '2019BreakTheLimit/FirstStage',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
    {
      path: 'firstDetail',
      component: () => import('./FirstDetail.vue'),
      name: '2019BreakTheLimit/FirstDetail',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
    {
      path: 'secondStage',
      component: () => import('./SecondStage.vue'),
      name: '2019BreakTheLimit/SecondStage',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
    {
      path: 'secondDetail',
      component: () => import('./SecondDetail.vue'),
      name: '2019BreakTheLimit/DetailPage',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
    {
      path: 'relativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019BreakTheLimit/RelativeNews',
      meta: {
        title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      },
    },
  ],
};
